import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { PrimeUploadFiles } from './prime-upload-files.component';
import {  FileUploadModule } from 'primeng/fileupload';
import { FileItemComponent } from './file-item/file-item.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A2FilesModule } from '@common/a2files-g/a2-files.module';
import { FilesContainerComponent } from './files-container/files-container.component';



@NgModule({
  declarations: [PrimeUploadFiles, FileItemComponent, FileUploadComponent, FilesContainerComponent],
  imports: [
    CommonModule,
    ProgressBarModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    A2FilesModule
  ],
  exports:[PrimeUploadFiles, FileUploadComponent, FileItemComponent, FilesContainerComponent]
})
export class PrimeUploadFilesModule { }
